import request from './request'

export function user_info(data) {
    return request({
        url: '/api/currentUser',
        method: 'get',
        params: data
    })
}

export function updateInfo(data) {
    return request({
        url: '/api/member/updateInfo',
        method: 'put',
        data: data
    })
}

export function modifyPassword(data) {
    return request({
        url: '/api/member/modifyPassword',
        method: 'put',
        data: data
    })
}

export function helpCategory(data) {
    return request({
        url: '/api/helpCenter/category',
        method: 'get',
        params: data
    })
}

export function helpList(data) {
    return request({
        url: '/api/helpCenter/list',
        method: 'get',
        params: data
    })
}

export function getListByTypeCode(data) {
    return request({
        url: '/api/category/getListByTypeCode',
        method: 'get',
        params: data
    })
}